<template>
   <v-dialog
      ref="dialog"
      v-model="modal"
      :persistent="!datereadonly"
      width="290px"
      @keydown.esc="modal = false"
   >
      <template v-slot:activator="{on, attrs}">
         <v-text-field
            :label="labelname"
            v-model="currentdate"
            readonly
            v-bind="attrs"
            v-on="on"
         ></v-text-field>
      </template>
      <v-date-picker
         v-model="currentdate"
         :readonly="datereadonly"
         @input="returnDate(date)"
         scrollable
      >
      </v-date-picker>
   </v-dialog>
</template>

<script>
   export default {
      props: {
         labelname: String,
         indate: String,
         datereadonly: {
            type: Boolean,
            default: function() {
               return false;
            },
         },
      },
      data() {
         return {
            dialog: false,
            modal: false,
            date: this.$globalstore.currentDateISOString().substr(0, 10),
         };
      },
      methods: {
         returnDate(date) {
            if (!this.datereadonly) {
               this.$refs.dialog.save(date);
               this.$emit("return-date", date);
            }
            this.modal = false;
         },

         allowDismissal() {
            return this.datereadonly ? true : false;
         },
      },
      computed: {
         currentdate: {
            get: function() {
               return !!this.indate ? this.indate : this.date;
            },
            set: function(newdate) {
               this.date = newdate;
            },
         },
      },
   };
</script>
